// The English half of what this product sends. Asserted against `mail-de.js`
// through the same key-parity test as everything else, because both are spread
// flat into the catalogue.
//
// Not a literal translation where a literal one would be wrong: German mail
// addresses the reader as `du` throughout and English simply does not have the
// distinction, so the register is carried by how direct the sentences are
// rather than by a pronoun.

export default {
  mailCodeSubject: (code) => `${code} is your tba.tips code`,
  mailCodeBody: (code, minutes) => [
    `Your sign-in code: ${code}`,
    ``,
    `It is valid for ${minutes} minutes, and only in the window that asked for it.`,
    `If this was not you, ignore this mail.`,
  ].join('\n'),

  mailDigestSubject: (count) => `This week: ${count === 1 ? 'one date' : `${count} dates`}`,
  mailDigestGreeting: (name) => (name ? `Hello ${name},` : 'Hello,'),
  mailDigestLede: 'here is what the institutions you follow have announced:',
  mailDigestAll: (url) => `See everything: ${url}`,
  mailDigestUnsubscribe: (url) => `You are getting this mail because you asked for it. Unsubscribe: ${url}`,

  mailInviteSubject: (account) => `You have been invited to ${account}`,
  mailInviteBody: (account, url, days) => [
    `${account} has invited you to help maintain their programme on tba.tips.`,
    ``,
    `Accept the invitation: ${url}`,
    ``,
    `The link is valid for ${days} days and works only with this e-mail address.`,
  ].join('\n'),
};
